import { useEffect, useState } from "react";
import LumiLogin from "./LumiLogin";
import LumiAuthCallback from "./LumiAuthCallback";
import LumiDashboard from "./LumiDashboard";
import { lumiFetch, clearLumiToken } from "./lumiApi";
import { LumiToaster } from "./lumiToast";

export default function LumiApp() {
  const [auth, setAuth] = useState({ status: "checking", user: null });

  // Synchronous detect of session_id in fragment (race-condition safe)
  const hasCallback = typeof window !== "undefined" && window.location.hash?.includes("session_id=");

  useEffect(() => {
    if (hasCallback) return;  // AuthCallback will handle it
    lumiFetch("/auth/me")
      .then((u) => setAuth({ status: "authed", user: u }))
      .catch(() => setAuth({ status: "anon", user: null }));
  }, [hasCallback]);

  const handleLogout = async () => {
    try { await lumiFetch("/auth/logout", { method: "POST" }); } catch {}
    clearLumiToken();
    setAuth({ status: "anon", user: null });
  };

  return (
    <>
      <LumiToaster />
      {hasCallback ? (
        <LumiAuthCallback
          onSuccess={(u) => setAuth({ status: "authed", user: u })}
          onError={() => setAuth({ status: "anon", user: null })}
        />
      ) : auth.status === "checking" ? (
        <div className="min-h-screen bg-[#0a0a0a] text-white flex items-center justify-center">
          <div className="text-sm text-white/50">Loading…</div>
        </div>
      ) : auth.status === "authed" ? (
        <LumiDashboard user={auth.user} onLogout={handleLogout} />
      ) : (
        <LumiLogin />
      )}
    </>
  );
}
